import React, { useContext, useMemo } from "react";
import { AppContext } from "../../appContext";
import { Spinner } from "../../components/spinner/Spinner";
import { leftMenu } from "../../mocks/dashboard";
import { Client } from "./components/client/Client";
import { DashboardContext } from "./DashboardContext";
import { formatDate1 } from "../../utils/dateFormats";
import { AnimatedMenu } from "../desktopPage/AnimatedMenu";
import { GoodScroll } from "../desktopPage/GoodScroll";
import { ScheduleTab } from "./components/scheduleTab/ScheduleTab";
import "./DashboardClients.css";

export const DashboardClients = ()=>{
    const dashboardContext = useContext(DashboardContext);
    const {
        selectedClientId, setSelectedClientId,
        editClientId, setEditClientId,
        selectedLeftMenuTabIndex, setSelectedLeftMenuTabIndex,
        setSelectedBottomMenuTabId,
        activePopup, setActivePopup,
        filteredClients
    } = dashboardContext;
    const contextData = useContext(AppContext);
    const { translate, currentLanguage } = contextData;
    const isClientsLoaded = !!contextData.clients;
    const clientsData = /*contextData.clients*/filteredClients || [];
    //const setClientsData = contextData.setClients;

    // Create translated menu items
    const translatedLeftMenu = useMemo(() => [
        translate('clients_switch_clients'),
        translate('clients_switch_schedule')
    ], [translate]);

    const clients = useMemo(()=>clientsData.map(it=>{
        return {
            id: it.id,
            name: it.name,
            date1: it.cachedDate1 ? formatDate1(new Date(it.cachedDate1), translate, currentLanguage) : '',
            date2: it.cachedDate2 ? formatDate1(new Date(it.cachedDate2), translate, currentLanguage) : '',
            avatarUrl: it.avatarUrl,
            waitLoading: it.waitLoading,
            customAvatarUrl: it.customAvatarUrl
        }
    }), [clientsData, translate, currentLanguage]);

    return (
        <div className="dashboard_clients">
            <AnimatedMenu items={translatedLeftMenu} selectedIndex={selectedLeftMenuTabIndex} onSelect={(index)=>setSelectedLeftMenuTabIndex(index)}></AnimatedMenu>
            {/*<div className="dashboard_tabButtons">
                {leftMenu.map((tab, index)=>(
                    <div className={`button dashboard_tabButton ${index == selectedLeftMenuTabIndex ? 'dashboard_tabButton_active' : ''}`}
                        onClick={()=>setSelectedLeftMenuTabIndex(index)}>
                        {tab}
                    </div>
                ))}
            </div>*/}

            <div className="dashboard_tabContents">
                {selectedLeftMenuTabIndex === 0 ? (
                    isClientsLoaded ? <GoodScroll className={'DashboardClients_scroll'}><div className="dashboard_tabContent dashboard_tabContent_clients">
                        {clients.map((client, index)=><Client 
                            key={client.id || index}
                            isOpen={client.id==selectedClientId}
                            data={client}
                            onOpen={()=>{
                                setSelectedClientId(client.id);
                                const alwaysToSessions = true;
                                if(!activePopup || activePopup == 'AddClient' || alwaysToSessions){ 
                                    setSelectedBottomMenuTabId('Sessions');
                                    setActivePopup('FullSessionList');
                                }
                                console.log(activePopup);
                            }}
                            onEdit={()=>{
                                console.log('edit');
                                setEditClientId(client.id);
                                setSelectedClientId(client.id);
                                setSelectedBottomMenuTabId('');
                                setActivePopup('EditClient');
                            }}
                            ></Client>
                        )}
                    </div></GoodScroll> : <Spinner></Spinner>
                ) : (
                    <GoodScroll className={'DashboardClients_scroll'}>
                        <div className="dashboard_tabContent dashboard_tabContent_schedule">
                            <ScheduleTab />
                        </div>
                    </GoodScroll>
                )}
            </div>
        </div>
    )
}